import { Minus, Plus } from '@untitledui/icons'

import ToolbarButton from '@components/toolbar/ToolbarButton'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'

interface ZooomButtonsProps {
  zoomIn: () => void
  zoomOut: () => void
  zoomInDisabled: boolean
  zoomOutDisabled: boolean
}

function ZoomButtons({ zoomIn, zoomOut, zoomInDisabled, zoomOutDisabled }: ZooomButtonsProps) {
  const { t } = useTypedTranslation()

  return (
    <div className='flex h-24 w-11 flex-col items-center justify-center'>
      <ToolbarButton
        label={t('storeMap.controls.zoomIn')}
        className='flex flex-1 items-center justify-center rounded-b-none border-b border-border-primary'
        onClick={zoomIn}
        isDisabled={zoomInDisabled}
      >
        <Plus/>
      </ToolbarButton>
      <ToolbarButton
        label={t('storeMap.controls.zoomOut')}
        className='flex flex-1 items-center justify-center rounded-t-none border-t-0'
        onClick={zoomOut}
        isDisabled={zoomOutDisabled}
      >
        <Minus/>
      </ToolbarButton>
    </div>
  )
}

export default ZoomButtons